<style lang="scss">
@import '~scss/_variables';

.results-wrapper {
    .logo-large {
        width: 100%;
    }

    &.bounce-enter,
    &.bounce-leave-to {
        transform: none;
    }
}

    .top-bar {
        display: flex;
        height: $grid-size * 1.5;

        background: $color-text-2;
        font-size: 18px;
        color: $color-white;

        .container {
            display: flex;
            align-items: center;
            justify-content: center;

            p {
                margin: 0;
                line-height: 1.4;
            }

            button {
                margin-left: 20px;
            }
        }

        @include media-smaller('md') {
            height: $grid-size * 2;
            font-size: 14px;
            text-align: left;

            .container {
                padding: 0 $mobile-pad;

                button {
                    font-size: 11px;
                    padding-left: 9px;
                    padding-right: 9px;
                }
            }
        }

        @include media-larger('sm') {
            & + .top-logo {
                margin-top: $grid-size / 2;
            }
        }
    }

    .top-logo {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: $grid-size;
        padding: 0 $grid-size;
        text-align: left;

        img {
            height: $grid-size;
        }

        @include media-smaller('md') {
            margin-top: $grid-size;
            padding: 0 $mobile-pad;
        }
    }

.results {
    max-width: 1360px;
    margin: $grid-size auto 0 auto;
    padding-top: 0.1px;
    position: relative;

    &:before {
        content: '';

        width: 20px;
        height: 20px;
        background: $color-text-2;
        border-radius: 50%;

        position: absolute;
            top: 0px;
            left: 0px;
    }

    .subtitle {
        font-family: $font-family-2;
        font-size: 14px;
        font-weight: lighter;
        text-transform: uppercase;
        letter-spacing: 4px;
        color: $color-black;
    }

    .separator {
        font-family: $font-family-2;
        font-weight: $font-weight-2-light;
        color: $color-border-accent-1-darker;
    }

    @include media-smaller('lg') {
        max-width: $grid-size * 18;
    }

    @include media-smaller('md') {
        width: 100%;
        max-width: none;
        margin-top: $grid-size;
        padding: 0.1px $mobile-pad;

        &:before {
            left: $mobile-pad;
        }

        .subtitle {
            text-align: left;
        }
    }

    .error {
        margin-bottom: ($grid-size * 4);
        font-size: 28px;

        h1 {
            font-family: $font-family-2;
            font-size: 2em;
            color: $color-white;
        }

        p {
            max-width: 26em;
            margin: $grid-size auto;
        }

        a {
            text-decoration: underline !important;
            cursor: pointer;
        }
    }
}

.container {
    max-width: $grid-size * 26;
    margin: 0 auto;
}

    #share {
        margin-bottom: $grid-size * 6;

        h2 {
            margin: 0 auto;
            position: relative;
            font-family: $font-family-2;
            font-weight: $font-weight-2-light;
            font-size: 64px;
            line-height: 0.95;
            text-align: left;
            color: $color-white;

            strong {
                font-weight: $font-weight-2-black;
            }

            small {
                display: inline-block;
                margin-top: calc(#{$grid-size} - 1.2em);
                margin-left: $grid-size * 3;
                padding-left: $grid-size;
                position: relative;

                font-family: $font-family-1;
                font-weight: $font-weight-1-regular;
                font-size: 16px;
                line-height: 1.44;
                color: $color-black;

                &:before {
                    content: '';
                    width: $grid-size / 2;
                    height: 1px;
                    position: absolute;
                        top: 0.8em;
                        left: 0;

                    background: $color-black;
                }
            } // small
        } // h2

        .links {
            margin: 87px 0;
            border-color: $color-black;
            position: relative;

            &:before,
            &:after,
            button + button:before {
                content: '';
                position: absolute;
                background: $color-black;
            }

            button {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 100%;
                padding: 20px;
                position: relative;

                font-family: $font-family-2;
                font-weight: $font-weight-2-bold;
                font-size: 22px;
                color: $color-white;
                transition: color $transition-hover;

                &:before {
                    left: -1px;
                }

                &:hover {
                    color: $color-black;

                    svg {
                        transform: scale(1.1);
                    }
                }

                svg {
                    margin-right: 15px;
                    font-size: 1.63em;
                    transition: transform $transition-hover;
                }
            }
        }

        @include media-larger('sm') {
            h2 {
                display: inline-block;
                width: $grid-size * 10;
            }

            .links {
                display: flex;
                flex-flow: row nowrap;
                border-bottom: 2px solid;

                &:before,
                &:after,
                button + button:before {
                    width: 2px;
                    height: $grid-size / 2;
                    bottom: 0;
                }

                &:before {
                    left: 0;
                }

                &:after {
                    right: 0;
                }
            }
        }

        @include media-smaller('md') {
            margin-bottom: $grid-size * 5;

            h2 {
                font-size: 42px;

                small {
                    margin-left: $grid-size;
                }
            }

            .links {
                margin: ($grid-size * 2) 0;
                margin-left: $grid-size;
                border-left: 1px solid;

                &:before,
                &:after,
                button + button:before {
                    width: $grid-size / 2;
                    height: 1px;
                    left: 0;
                }

                &:before {
                    top: 0;
                }

                &:after {
                    bottom: 0;
                }

                button + button:before {
                    top: 0;
                }

                button {
                    height: $grid-size * 2;
                    justify-content: flex-start;
                    padding-left: $grid-size;
                    font-size: 18px;

                    svg {
                        width: $grid-size / 2;
                        margin-right: $grid-size / 2;
                        font-size: $grid-size / 2;
                    }
                }
            }
        }
    } // #share

    .results footer {
        display: flex;
        align-items: flex-end;
        justify-content: space-between;
        margin-bottom: 54px;
        line-height: 1.7;

        p {
            margin: 0;
            text-align: left;
        }

        @include media-larger('sm') {
            .visible-mobile {
                display: none;
            }
        }

        @include media-smaller('md') {
            margin-bottom: $grid-size;

            .right {
                text-align: right;
            }
        }
    }
</style>

<template>
    <transition name="bounce">
        <div class="results-wrapper">
            <div v-if="!$store.state.hasCalculated" class="top-bar">
                <div class="container">
                    <p>Hey, did you know that you can <strong>calculate your emissions</strong> too!</p>
                    <router-link tag="button" to="/form" class="rect arrow">
                        <span>Calculate</span> <fa :icon="['fas', 'arrow-square-right']"></fa>
                    </router-link>
                </div>
            </div>

            <div class="top-logo">
                <router-link to="/" class="logo-link">
                    <img src="@/assets/img/logo.svg" alt="Mission Emission">
                </router-link>

                <router-link to="/about">
                    &mdash; About
                </router-link>
            </div>

            <main class="results">
                <div class="container">
                    <ResultsData v-if="$store.state.results.result"></ResultsData>
                    <div v-else class="error">
                        <h1>Unfortunately...</h1>
                        <p>The air is too polluted for our servers to work properly and we couldn't calculate how much emissions you would produce on your journey. You could <router-link to="/form">try again</router-link>!</p>
                    </div>

                    <section id="share">
                        <h2>
                            <strong>Share</strong><br>
                            The Results<br>
                            <small>
                                with your friends<br>
                                and raise awareness
                            </small>
                        </h2>

                        <div class="links">
                            <button v-for="(option, key) in shareOptions" :key="key" @click="socialAction(key)">
                                <fa :icon="option.icon"></fa> {{ option.text }}
                            </button>
                        </div>
                    </section>

                    <footer>
                        <p class="left">
                            A project by &mdash;<br>
                            <a :href="presets('links').companies.oblik" target="_blank">Oblik Studio</a>
                            &amp;
                            <a :href="presets('links').companies.betapeak" target="_blank">Beta Peak</a>
                        </p>

                        <router-link to="/about" class="right">
                            &mdash; About<br class="visible-mobile"> the Project
                        </router-link>
                    </footer>
                </div>
            </main>

            <router-link to="/" class="logo-link">
                <img class="logo-large" src="../assets/img/logo-large-alt.svg" alt="Mission Emission">
            </router-link>
        </div>
    </transition>
</template>

<script>
import store from '@/store';
import formatter from '@/mixins/formatter';
import * as social from '@/modules/social';
import ResultsData from '@/components/ResultsData';

function loadResultsGuard (to, from, next) {
    store.dispatch(
        'loading',
        store.dispatch('changeActiveResult', to.params.id).then(function (data) {
            next();
        })
    );
}

export default {
    beforeRouteEnter: loadResultsGuard,
    beforeRouteUpdate: loadResultsGuard,
    components: { ResultsData },
    mixins: [
        formatter
    ],
    data () {
        return {
            shareUrl: window.location.href,
            shareOptions: {
                facebook: {
                    icon: ['fab', 'facebook'],
                    text: 'Share'
                },
                twitter: {
                    icon: ['fab', 'twitter'],
                    text: 'Tweet'
                },
                link: {
                    icon: ['far', 'link'],
                    text: 'Get Link'
                }
            }
        };
    },
    methods: {
        socialAction (action) {
            var emissions = this.formatUnit(this._convert(this.$store.getters.baseTravelMode.emissions.total, 'g')),
                origin = this.$store.getters.journey.originText.main,
                destination = this.$store.getters.journey.destinationText.main;

            if (action === 'facebook') {
                social.facebookPopup({
                    url: this.shareUrl
                });
            } else if (action === 'twitter') {
                social.twitterPopup({
                    url: this.shareUrl,
                    text: 'I would produce ' + emissions + ' emissions on a trip from ' + origin + ' to ' + destination + '.'
                });
            } else if (action === 'link') {
                this.shareOptions.link.text = social.copy(this.shareUrl)
                    ? 'Copied!'
                    : 'Copy failed';
            }
        }
    }
};
</script>
